import React from "react";
import styles from "./Evs.module.scss";
import Ethical from "./Ethical/Ethical";
import Versatile from "./Versatile/Versatile";
import Scalable from "./Scalable/Scalable";
function Evs() {
  return (
    <div className={styles["evs-wrapper"]}>
      <Ethical
        image="/chair-img.png"
        title="Data Acquisition"
        subTitle="From various eTail sources"
        text="Data acquisition involves sourcing product data from a wide range of eTail platforms, including major online retailers and marketplaces. By utilizing secured data sourcing, APIs, and data feeds, we gather key information on pricing, availability, consumer reviews, and product attributes."
      />
      <Versatile
        image="/data-harmonization.png"
        title="Data Harmonisation"
        subTitle="With Data Normalisation"
        text="Data harmonization ensures that data collected from various sources is standardized and made consistent across all platforms. By applying data normalization techniques, we remove redundancies and resolve discrepancies in product information, reviews, and pricing. This process structures data into uniform formats like JSON or CSV, making it easier to analyze and integrate with different systems."
      />
      <Ethical
        image="/data-discovery.png"
        title=" Data Discovery "
        subTitle=" With our Data Lake"
        text="Our data lake allows businesses to store and manage vast amounts of structured and unstructured data, collected from various eCommerce channels. With advanced data discovery tools, users can easily search, query, and analyze data for patterns and trends."
      />
      <Versatile
        image="/product-affilation.png"
        title="Product Affiliation"
        subTitle="With Adaptive scoring"
        text="Our adaptive scoring algorithm analyzes customer behavior, preferences, and purchasing patterns to assign scores to products based on their relevance and affiliation. This process helps businesses understand which products are frequently bought together or viewed as complementary. With adaptive scoring, businesses can offer personalized recommendations and bundles, enhancing customer experience and driving sales"
      />
      <Ethical
        image="/product-relation-discovery.png"
        title="Product relation discovery"
        subTitle="  With Knowledge Graphs"
        text="Knowledge graphs help businesses understand the complex relationships between products by mapping connections based on attributes like category, brand, and features. By analyzing data in a visual graph format, product relation discovery becomes seamless, enabling businesses to identify opportunities for cross-selling, up-selling, or bundling."
      />
      <Versatile
        image="/data-monetization.png"
        title="Data Monetisation"
        subTitle="  With Omni-channel marketing"
        text="Data monetization through omni-channel marketing leverages insights from collected data to target consumers across multiple platforms, such as email, social media, SMS, and mobile notifications. By integrating these channels, businesses can create personalized marketing campaigns that reach customers at the right time and on the right platform. This approach increases engagement, boosts conversion rates, and maximizes return on investment."
      />
    </div>
  );
}

export default Evs;
